import { ApprovedTypesEnum } from 'APIPackage/KnmModule/enums/ApprovedTypesEnum';

interface IErknmOrganizationNameFieldEnabledWithoutFizProps {
  itemIzFiz: boolean;
  isNewOrganizationTemplate?: boolean;
  isSupervisor: boolean | undefined;
  isNewKnm: boolean | undefined;
  isKnmStatusFillInProcess: boolean | undefined;
  isKnmStatusReadyForApprove: boolean | undefined;
  isKnmPlanStatusConsidered: boolean;
  knmDataApprovedType: ApprovedTypesEnum | null | undefined;
  knmDataNote: string | null | undefined;
  isWatchOnly: boolean | undefined;
}

export const isErknmOrganizationNameFieldEnabledWithoutFiz = ({
  itemIzFiz,
  isNewOrganizationTemplate,
  isKnmPlanStatusConsidered,
  isKnmStatusFillInProcess,
  isKnmStatusReadyForApprove,
  isNewKnm,
  isSupervisor,
  knmDataApprovedType,
  knmDataNote,
  isWatchOnly,
}: IErknmOrganizationNameFieldEnabledWithoutFizProps) =>
  !isWatchOnly &&
  isSupervisor &&
  (isNewOrganizationTemplate || isNewKnm || isKnmStatusFillInProcess || (isKnmStatusReadyForApprove && itemIzFiz)) &&
  !(isKnmPlanStatusConsidered && knmDataApprovedType === ApprovedTypesEnum.APPROVED && !!knmDataNote);
